// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2504":"8afc6be8","3035":"b7b91cb1","3837":"8afc6be8","5572":"8afc6be8","7784":"b7b91cb1","7823":"aee098fc","8688":"9923b5b2","8871":"b7b91cb1"}[chunkId] + ".chunk.css";
};